/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Open_Issues_AssignedInputs */

const en_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} assigned to you`)
};

const de_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dir zugewiesen`)
};

const es_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} asignados a ti`)
};

const fr_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} qui vous sont assignés`)
};

const nl_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} aan jou toegewezen`)
};

const it_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} assegnati a te`)
};

const pt_br2_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} atribuídos a você`)
};

const pl_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} przypisanych do ciebie`)
};

const hu_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hozzád rendelve`)
};

const ro_admin_dashboard_open_issues_assigned = /** @type {(inputs: Admin_Dashboard_Open_Issues_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} atribuite dumneavoastra`)
};

/**
* | output |
* | --- |
* | "{count} assigned to you" |
*
* @param {Admin_Dashboard_Open_Issues_AssignedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_open_issues_assigned = /** @type {((inputs: Admin_Dashboard_Open_Issues_AssignedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Open_Issues_AssignedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "de") return de_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "es") return es_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "fr") return fr_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "nl") return nl_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "it") return it_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "pl") return pl_admin_dashboard_open_issues_assigned(inputs)
	if (locale === "hu") return hu_admin_dashboard_open_issues_assigned(inputs)
	return ro_admin_dashboard_open_issues_assigned(inputs)
});
export { admin_dashboard_open_issues_assigned as "admin.dashboard.open_issues_assigned" }